/* tjs <- make-error.ts */

/* line 1 */
function stringify(x) {
    try {
        return JSON.stringify(x);
    }
    catch (_) {
        return '{has circular references}';
    }
}
stringify.__tjs = {
  "params": {
    "x": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "make-error.ts:1"
}

/* line 9 */
export function makeError(...messages) {
    return new Error(messages.map(stringify).join(' '));
}
makeError.__tjs = {
  "params": {
    "messages": {
      "type": {
        "kind": "array",
        "items": {
          "kind": "null"
        }
      },
      "required": false
    }
  },
  "unsafe": true,
  "source": "make-error.ts:14"
}